import gql from "graphql-tag";

export const CANCELLATION_REASONS_QUERY = gql`
  query CancellationReasons {
    cancellationReasons {
      id
      name
    }
  }
`;
